import apiClient from './api';
import { Marker, ViewportMarkersResponse } from '@citiguide/shared';

export interface GetMarkersParams {
  language?: string;
  categoryId?: string;
  bounds?: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
}

export const markerService = {
  /**
   * Get all active markers (public read-only)
   * Public backend filters by subdomain automatically
   */
  getMarkers: async (params?: GetMarkersParams): Promise<Marker[]> => {
    const response = await apiClient.get<Marker[]>('/api/markers', { params });
    return response.data;
  },

  /**
   * Get a single marker by ID (public read-only)
   */
  getMarker: async (markerId: string): Promise<Marker> => {
    const response = await apiClient.get<Marker>(`/api/markers/${markerId}`);
    return response.data;
  },

  /**
   * Submit an anonymous rating (1–5) for a marker
   */
  rateMarker: async (markerId: string, value: number): Promise<void> => {
    await apiClient.post(`/api/markers/${markerId}/rating`, { value });
  },
};

/**
 * Get markers within a viewport with server-side clustering support.
 * Used by useViewportMarkers hook from frontend-core.
 */
export async function getViewportMarkers(params: {
  bounds: string;
  zoom: number;
  language?: string;
  categories?: string;
  audience?: string;
  price?: string;
  kind?: string;
  near?: string;
}): Promise<ViewportMarkersResponse> {
  const response = await apiClient.get<ViewportMarkersResponse>('/api/markers', {
    params: {
      bounds: params.bounds,
      zoom: params.zoom,
      language: params.language,
      ...(params.categories ? { categories: params.categories } : {}),
      ...(params.audience ? { audience: params.audience } : {}),
      ...(params.price ? { price: params.price } : {}),
      ...(params.kind ? { kind: params.kind } : {}),
      ...(params.near ? { near: params.near } : {}),
    },
  });
  return response.data;
}

